import React, { useState } from 'react';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { IconButton, Popover, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import moment from 'moment';
export default function DatepickerStatic({ voyageDetails, dateData, onlyear = false }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs(voyageDetails?.fromDate));

  const openPicker = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closePicker = (event) => {
    setAnchorEl(null);
  };

  const handleDateChange = (date) => {
    dateData(date);
    if (!onlyear) {
      if (moment(new Date(selectedDate)).format('MMM') !== moment(new Date(date)).format('MMM')) {
        setSelectedDate(date);
        closePicker();
      }
    } else {
      setSelectedDate(date);
      closePicker();
    }
  };
  return (
    <div>
      <IconButton
        sx={{ display: 'flex', justifyContent: 'space-around', borderRadius: '0px', alignItems: 'center' }}
        onClick={openPicker}
      >
        <Typography style={{ fontSize: '12px', color: '#14285A', fontWeight: '500' }}>{onlyear ? moment(new Date(selectedDate)).format('YYYY') : moment(new Date(selectedDate)).format('MMM YYYY')}</Typography>
        <ArrowDropDownIcon style={{ fontSize: '16px', transform: anchorEl ? 'rotate(180deg)' : null }} />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={closePicker}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StaticDatePicker
            sx={{
              '.MuiDialogActions-root': {
                display: 'none',
              },
            }}
            // minDate={dayjs(new Date(voyageDetails?.fromDate))}
            // maxDate={dayjs(new Date(voyageDetails?.toDate))}
            value={selectedDate}
            showToolbar={false}
            openTo="year"
            views={onlyear ? ['year'] : ['month', 'year']}
            onChange={(event) => {
              handleDateChange(event);
            }}
            toolbarFormat={false}
            pickersToolbar={false}
            disableFuture
            format="MM/yyyy"
          />
        </LocalizationProvider>
      </Popover>
    </div>
  );
}
